module.exports = "/assets/9ddee3dba9e47f0a4a23bb7d4363b7b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/v2-icons/rail.svg
// module id = 218
// module chunks = 0